// extracted by mini-css-extract-plugin
module.exports = {"padding-label":"src-_components-___BookingReferenceSearchPanel-module__padding-label___29dG8","form":"src-_components-___BookingReferenceSearchPanel-module__form____VILj"};